import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { log } from '@atlassian/mpac-utils';
import FeatureFlagWebClient, { EvaluationReason } from '@atlassiansox/feature-flag-web-client';
import * as Immutable from 'immutable';
import FrontendFeatureFlagsMockClient from "./FrontendFeatureFlagsMockClient";
export class FeatureFlags {
  constructor(client, userIdentifier) {
    _defineProperty(this, "_client", void 0);

    _defineProperty(this, "_userIdentifier", void 0);

    _defineProperty(this, "_featureFlagNames", void 0);

    this._client = client;
    this._userIdentifier = userIdentifier;

    const featureFlags = this._client.getFlags();

    this._featureFlagNames = Object.keys(featureFlags);
    this.logWarningForFallbackValues(featureFlags);
  }

  logWarningForFallbackValues(featureFlags) {
    Object.keys(featureFlags).forEach(key => {
      var _featureFlags$key$eva;

      if (((_featureFlags$key$eva = featureFlags[key].evaluationDetail) === null || _featureFlags$key$eva === void 0 ? void 0 : _featureFlags$key$eva.reason) === EvaluationReason.ERROR) {
        const {
          value,
          evaluationDetail
        } = featureFlags[key];
        log.warn('FeatureFlags', 'Error: Serving the fallback value', {
          name: key,
          fallbackValue: value,
          errorKind: evaluationDetail === null || evaluationDetail === void 0 ? void 0 : evaluationDetail.errorKind
        });
      }
    });
  }

  getFlag(flagName, defaultValue, options) {
    const rawFlag = this._client.getFlagDetails(flagName, defaultValue, options);

    if (this._featureFlagNames.includes(flagName)) {
      this.logWarningForFallbackValues({
        [flagName]: rawFlag
      });
    }

    return rawFlag.value;
  }

  getAllFlags() {
    const flags = this._client.getFlags();

    let allFlags = {};
    allFlags = Object.keys(flags).reduce((flagsAll, key) => {
      flagsAll[key] = flags[key].value;
      return flagsAll;
    }, allFlags);
    return Immutable.Map(allFlags);
  }

  changeUserIdentifier(userId) {
    return this._client.updateFeatureFlagUser(userId);
  }

  resetUserIdentifier() {
    return this._client.updateFeatureFlagUser(this._userIdentifier);
  }

}

function getUser(userId, additionalIds, customAttributes = {}) {
  let user;
  const tenantId = additionalIds === null || additionalIds === void 0 ? void 0 : additionalIds.tenantId;

  if (userId) {
    user = {
      identifier: {
        type: 'atlassianAccountId',
        value: userId
      },
      isAnonymous: false,
      additionalIdentifiers: {},
      custom: customAttributes
    };
  } else {
    user = {
      identifier: {
        type: 'ffClientAnonymousId',
        value: 'marketplace-anonymous'
      },
      isAnonymous: true,
      additionalIdentifiers: {},
      custom: customAttributes
    };
  }

  if (tenantId) {
    user.additionalIdentifiers.tenantId = tenantId;
  }

  return user;
}

function initFeatureFlagsClient(productKey, apiKey, environment, user, analyticsClient) {
  const clientOptions = {
    productKey,
    environment
  };
  return new FeatureFlagWebClient(apiKey, analyticsClient, user, clientOptions);
}

export function getFeatureFlagsClient({
  apiKey,
  environment,
  userId,
  additionalIds,
  analyticsClient,
  productKey,
  customAttributes
}) {
  const user = getUser(userId, additionalIds, customAttributes);
  const featureFlagsClient = initFeatureFlagsClient(productKey, apiKey, environment, user, analyticsClient);
  return featureFlagsClient.ready().then(() => new FeatureFlags(featureFlagsClient, user));
}
export function makeTestFeatureFlags(flags) {
  return new FeatureFlags(new FrontendFeatureFlagsMockClient(flags), {
    identifier: {
      type: 'ffClientAnonymousId',
      value: 'marketplace-anonymous'
    },
    isAnonymous: true,
    additionalIdentifiers: {}
  });
}